import { Component, OnInit, Optional } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { TypeConceptEnums } from 'src/app/enum/type-concept-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { ChargeAccountService } from 'src/app/services/others/charge-account.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-annul-charge-account',
  templateUrl: './annul-charge-account.component.html',
  styleUrls: ['./annul-charge-account.component.scss'],
  standalone: false
})
export class AnnulChargeAccountComponent implements OnInit {
  chargeAccountModel: InvoiceModel = new InvoiceModel();
  chargeAccountId: number = 0;
  disableButton: boolean = false;
  formChargeAccount: FormGroup = new FormGroup({});
  listConcepts: CustomListDropdown[] = [];
  typeConcept: number = TypeConceptEnums.anulacion;
  suscription: Subscription;

  constructor(
    private chargeAccountService: ChargeAccountService,
    private dateConverterService: DateConverterService,
    private formBuilder: UntypedFormBuilder,
    private confirmDialogService: ConfirmDialogService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm(new InvoiceModel);
    this.getAllLists();
  }

  async ngOnInit(): Promise<void> {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.chargeAccountModel = inputs.chargeAccountModel;
    });
    this.initialChargeAccount();

  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async annulChargeAccount() {
    if (this.formChargeAccount.invalid) {
      this.showValidationMessages();
      return;
    }
    const modelChargeAccount = this.formChargeAccount.getRawValue() as InvoiceModel;
    let mensaje = "¿Realmente desea ANULAR esta cuenta de cobro? <br>Luego de anulada la cuenta de cobro no podra ser modificada";
    if (modelChargeAccount.accountingInterfaceId) {
      mensaje = "Esta cuenta de cobro YA tiene INTERFAZ. Luego de anulada una cuenta de cobro no podra ser modificada. ¿Realmente desea ANULARLA?";
    }
    const accepted = await this.confirmDialogService.confirm(mensaje);
    if (accepted) {
      if (modelChargeAccount.observationAnnul === "") modelChargeAccount.observationAnnul = null;
      this.chargeAccountModel.conceptAnnulId = modelChargeAccount.conceptAnnulId;
      this.chargeAccountModel.dateAnnul = modelChargeAccount.dateAnnul;
      this.chargeAccountModel.observationAnnul = modelChargeAccount.observationAnnul;
      try {
        const response = await firstValueFrom(this.chargeAccountService.annulChargeAccount(this.chargeAccountModel));
        const data: ModalObjectType = {};
        data.params = { updateChargeAccount: response };
        this.ref.close(data);
      } catch (error) {
        console.error('Error al anular la cuenta de cobro.', error);
      }
    }
  }

  initialChargeAccount() {
    if (this.chargeAccountModel.conceptAnnulId != null && this.chargeAccountModel.conceptAnnulId != 0) {
      this.disableButton = true;
      this.validateForm(this.chargeAccountModel)
      setTimeout(() => this.formChargeAccount.disable(), 100);
    } else {
      this.disableButton = false;
      this.getConcept(null)
      this.chargeAccountModel.dateAnnul = new Date();
      this.validateForm(this.chargeAccountModel)
      setTimeout(() => this.formChargeAccount.enable(), 100);
    }
  }

  async getAllLists() {
    try {
      const [concept] = await Promise.all([
        firstValueFrom(this.chargeAccountService.getAllConceptForSelectAsync()),
      ]);
      this.listConcepts = concept;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
    }
  }

  async getConcept(conceptAnnulId: number | null) {
    const concept = this.listConcepts.find(x => x.value === conceptAnnulId);
    this.formChargeAccount.patchValue({
      conceptAnnulId: concept ? conceptAnnulId : null
    });
  }

  showValidationMessages() {
    const controlMessages: any = {
      conceptAnnulId: {
        required: 'El campo concepto es obligatorio.',
        min: 'Debe seleccionar un concepto válido.'
      },
      dateAnnul: {
        required: 'El campo fecha es obligatorio.'
      },
      observationAnnul: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      },
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formChargeAccount.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm(chargeAccount: InvoiceModel) {
    this.formChargeAccount = this.formBuilder.group({
      branchId: [chargeAccount.branchId, []],
      enterpriseId: [chargeAccount.enterpriseId, []],
      conceptAnnulId: [chargeAccount.conceptAnnulId, [Validators.required, Validators.min(1)]],
      chargeAccountStateId: [chargeAccount.invoiceStateId, []],
      dateAnnul: [chargeAccount.dateAnnul ? this.dateConverterService.convertDatePreserveDay(chargeAccount.dateAnnul) : null, [Validators.required]],
      observationAnnul: [chargeAccount.observationAnnul, [Validators.maxLength(250)]]
    });
  }
}
